import {
    Dropdown,
    Option,
    Field,
    DropdownProps,
    FieldProps,
} from '@fluentui/react-components';
import { ReportingTeamItem } from '../../../hooks/useReportingTeamItems';
import { useMemo } from 'react';

export interface TeamsFilterDropdownProps {
    teams: ReportingTeamItem[];
    teamLabel?: FieldProps['label'];
    teamPlaceholder?: string;
    selectedTeamId: string | null;
    allTeamsOption: ReportingTeamItem;
    dropdownAppearance?: DropdownProps['appearance'];
    disabled?: boolean;
    fieldClassName?: string;
    onTeamChange?: (id: string) => void;
}

const TeamsFilterDropdown: React.FC<TeamsFilterDropdownProps> = ({
    teams,
    allTeamsOption,
    selectedTeamId,
    teamLabel,
    teamPlaceholder,
    dropdownAppearance,
    disabled,
    fieldClassName,
    onTeamChange,
}) => {
    const selectedTeamName = useMemo(() => {
        if (!allTeamsOption) {
            return '';
        }

        const teamId = selectedTeamId || allTeamsOption.id;
        return (
            teams.find((team) => team.id === teamId)?.name ??
            allTeamsOption.name
        );
    }, [allTeamsOption, selectedTeamId, teams]);

    return (
        <Field label={teamLabel} className={fieldClassName}>
            <Dropdown
                appearance={dropdownAppearance}
                placeholder={teamPlaceholder}
                selectedOptions={[selectedTeamId || allTeamsOption.id]}
                value={selectedTeamName}
                onOptionSelect={(_, data) => {
                    if (onTeamChange) {
                        onTeamChange(data.optionValue || allTeamsOption.id);
                    }
                }}
                disabled={disabled}
            >
                <Option key={allTeamsOption.id} value={allTeamsOption.id}>
                    {allTeamsOption.name}
                </Option>
                {teams
                    .filter((option) => option.id !== allTeamsOption.id)
                    .map((option) => (
                        <Option key={option.id} value={option.id}>
                            {option.name}
                        </Option>
                    ))}
            </Dropdown>
        </Field>
    );
};

export default TeamsFilterDropdown;
